import { render, staticRenderFns } from "./EventStudentComponent.vue?vue&type=template&id=13493f6a&scoped=true&"
import script from "./EventStudentComponent.vue?vue&type=script&lang=js&"
export * from "./EventStudentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13493f6a",
  null
  
)

export default component.exports